import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/icon_sph.png';
import _imports_1 from '../../assets/weapp_nam.png';
import _imports_2 from '../../assets/xiaochengxu.png';
import _imports_3 from '../../assets/dianhua.png';
const _withScopeId = n => (_pushScopeId("data-v-4775e2c3"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "top_text"
};
const _hoisted_2 = {
  class: "names"
};
const _hoisted_3 = {
  class: "times"
};
const _hoisted_4 = {
  class: "content"
};
const _hoisted_5 = {
  key: 0,
  class: "word"
};
const _hoisted_6 = {
  class: "tops_sword"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "bt_right"
};
const _hoisted_9 = {
  class: "text_1"
};
const _hoisted_10 = {
  class: "text_2"
};
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = {
  key: 3,
  class: "agree"
};
const _hoisted_13 = {
  key: 4,
  class: "agree"
};
const _hoisted_14 = {
  key: 5,
  class: "revoke"
};
const _hoisted_15 = {
  key: 6,
  class: ""
};
const _hoisted_16 = {
  class: "red-box"
};
const _hoisted_17 = {
  class: "red-text"
};
const _hoisted_18 = {
  key: 7,
  class: "boxs_sph"
};
const _hoisted_19 = {
  class: "box_sphfeed"
};
const _hoisted_20 = {
  class: "one_cont"
};
const _hoisted_21 = {
  class: "titles_sphfeed"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img_icon",
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_23 = {
  class: "title_text"
};
const _hoisted_24 = {
  key: 8,
  class: "addrss_box"
};
const _hoisted_25 = {
  class: "message_"
};
const _hoisted_26 = {
  class: "title_s"
};
const _hoisted_27 = {
  class: "loctions"
};
const _hoisted_28 = {
  key: 9,
  class: "cont_texts"
};
const _hoisted_29 = {
  key: 10,
  class: "cont_texts"
};
const _hoisted_30 = {
  key: 11,
  class: "cont_texts"
};
const _hoisted_31 = ["src"];
const _hoisted_32 = {
  key: 12,
  class: "box_weapp"
};
const _hoisted_33 = {
  class: "weapp_name"
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "weapp_icon",
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_35 = {
  class: "weapp_title"
};
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "botom_weapp"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "icon_weapp",
  src: _imports_2,
  alt: ""
}), /*#__PURE__*/_createElementVNode("span", {
  class: "text_weapp"
}, "小程序")], -1));
const _hoisted_37 = {
  class: "url_"
};
const _hoisted_38 = {
  class: "link_boxs"
};
const _hoisted_39 = {
  class: "title_bts"
};
const _hoisted_40 = {
  class: "titles_nrs"
};
const _hoisted_41 = {
  class: "voiptext_box"
};
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "通话时长", -1));
const _hoisted_43 = {
  style: {
    "margin-left": "10px"
  }
};
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "imgs1",
  src: _imports_3,
  alt: ""
}, null, -1));
const _hoisted_45 = {
  key: 15
};
const _hoisted_46 = {
  key: 16,
  class: "card_name"
};
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "corpname"
}, "名称", -1));
const _hoisted_48 = {
  class: "nam_ops"
};
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "userid"
}, "个人名片", -1));
import voice from "./voice.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'item',
  props: {
    index: {
      type: Number,
      default: 0
    },
    items: {
      type: Object,
      required: true
    },
    types: {
      type: Number,
      default: 1
    },
    from: {
      type: String,
      default: ""
    }
  },
  setup(__props) {
    const props = __props;
    const get_time = () => {
      return new Date().getTime();
    };
    const get_message = (message, index) => {
      if (index == 1) {
        return JSON.parse(message).content;
      }
      if (index == 2) {
        return JSON.parse(message).file;
      }
      //3,video,4:image,5voice,6weapp,7voiptext8file,9location 10 external_redpacket 11card
      if (index == 3) {
        return JSON.parse(message).file;
      }
      if (index == 4) {
        return JSON.parse(message).file;
      }
      if (index == 5) {
        return JSON.parse(message).file;
      }
      if (index == 6) {
        return JSON.parse(message);
      }
      if (index == 5.1) {
        return JSON.parse(message).play_length;
      }
      if (index == 7) {
        return JSON.parse(message);
      }
      if (index == 8) {
        return JSON.parse(message);
      }
      if (index == 9) {
        return JSON.parse(message);
      }
      if (index == 10) {
        return JSON.parse(message);
      }
      if (index == 11) {
        return JSON.parse(message);
      }
      //12 sphfeed
      if (index == 12) {
        return JSON.parse(message);
      }
      //13 link
      if (index == 13) {
        return JSON.parse(message);
      }
    };
    //
    const date_time = item => {
      //item是秒数，就纯数字，帮我转化成 00:59的格式。如果超过 60 就变成 01:00，按60的倍数算
      // 计算分钟数
      const minutes = Math.floor(item / 60);
      // 计算剩余的秒数
      const seconds = item % 60;
      // 格式化分钟和秒，确保它们都是两位数
      const formattedMinutes = minutes.toString().padStart(2, "0");
      const formattedSeconds = seconds.toString().padStart(2, "0");
      // 返回格式化后的字符串
      return `${formattedMinutes}:${formattedSeconds}`;
    };
    const set_bark = links => {
      //新窗口打开
      window.open(links);
    };
    const get__size = item => {
      //转化下文件大小 如果是是 1M 一下显示 kb 。以上显示 M
      if (item < 1024) {
        return item + "kb";
      }
      if (item < 1024 * 1024) {
        return (item / 1024).toFixed(2) + "kb";
      }
      return (item / (1024 * 1024)).toFixed(2) + "M";
      // return (item/(1024*1024)).toFixed(2)+'M'
    };

    const get_fileext = item => {
      console.error(item);
      //item包含xlsx
      if (item == "docx") {
        return require("../../assets/docx.png");
      }
      if (item == "pdf") {
        return require("../../assets/pdf.png");
      }
      if (item == "pptx") {
        return require("../../assets/pptx.png");
      }
      if (item == "jpg") {
        return require("../../assets/jpg.png");
      }
      if (item == "xlsx") {
        return require("../../assets/xlsx.png");
      }
    };
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", {
        class: _normalizeClass(["box_ops_item", __props.types == 2 || __props.items.user_type == 1 || __props.items.tolist == __props.from ? '_left' : '_right'])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, _toDisplayString(__props.items.user_type == 1 && __props.items.customer ? __props.items.customer.name + "(" + __props.items.customer.remark + ")" : __props.items.user ? __props.items.user.name : ""), 1), _createElementVNode("span", {
        class: _normalizeClass(["tags", __props.items.user_type == 1 ? 'tags_left' : 'tags_right'])
      }, _toDisplayString(__props.items.user_type == 1 ? "@微信" : "@" + (__props.items.user?.dept_name || "")), 3), _createElementVNode("span", _hoisted_3, _toDisplayString(__props.items.msg_time), 1)]), _createElementVNode("div", _hoisted_4, [__props.items.msgtype == 'file' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
        class: "imgs",
        src: get_fileext(get_message(__props.items.content, 8).fileext),
        alt: ""
      }, null, 8, _hoisted_7), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString(get_message(__props.items.content, 8).filename), 1), _createElementVNode("span", _hoisted_10, _toDisplayString(get__size(get_message(__props.items.content, 8).filesize)), 1)])])])) : __props.items.msgtype == 'image' ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_el_image, {
        class: "img_boxs",
        src: get_message(__props.items.content, 2),
        "zoom-rate": 1.2,
        "max-scale": 7,
        "min-scale": 0.2,
        "preview-src-list": [get_message(__props.items.content, 4)],
        fit: "cover"
      }, null, 8, ["src", "preview-src-list"])])) : __props.items.msgtype == 'text' ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: _normalizeClass(["cont_texts", __props.items.user_type == 1 ? 'color_11' : 'color_22'])
      }, _toDisplayString(get_message(__props.items.content, 1)), 3)) : __props.items.msgtype == 'agree' ? (_openBlock(), _createElementBlock("div", _hoisted_12, " 对方同意会话存档内容 ")) : __props.items.msgtype == 'disagree' ? (_openBlock(), _createElementBlock("div", _hoisted_13, " 对方不同意会话存档内容 ")) : __props.items.msgtype == 'revoke' ? (_openBlock(), _createElementBlock("div", _hoisted_14, " 你撤回了一条消息 ")) : __props.items.msgtype == 'external_redpacket' || __props.items.msgtype == 'redpacket' ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString(get_message(__props.items.content, 10).wish), 1)])])) : __props.items.msgtype == 'sphfeed' ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("span", _hoisted_20, _toDisplayString(get_message(__props.items.content, 12).feed_desc), 1)]), _createElementVNode("div", _hoisted_21, [_hoisted_22, _createElementVNode("span", _hoisted_23, _toDisplayString(get_message(__props.items.content, 12).sph_name), 1)])])) : __props.items.msgtype == 'location' ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, _toDisplayString(get_message(__props.items.content, 9).address), 1), _createElementVNode("div", _hoisted_26, _toDisplayString(get_message(__props.items.content, 9).title), 1), _createElementVNode("div", _hoisted_27, " 经纬度：" + _toDisplayString(get_message(__props.items.content, 9).longitude) + _toDisplayString(get_message(__props.items.content, 9).latitude), 1)])) : __props.items.msgtype == 'emotion' ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createVNode(_component_el_image, {
        class: "img_gifboxs",
        src: get_message(__props.items.content, 2),
        "zoom-rate": 1.2,
        "max-scale": 7,
        "min-scale": 0.2,
        "preview-src-list": [get_message(__props.items.content, 2)],
        fit: "cover"
      }, null, 8, ["src", "preview-src-list"])])) : __props.items.msgtype == 'voice' ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createVNode(voice, {
        duration: get_message(__props.items.content, 5.1),
        uniqueKey: get_time(),
        amrUrl: get_message(__props.items.content, 5)
      }, null, 8, ["duration", "uniqueKey", "amrUrl"])])) : __props.items.msgtype == 'video' ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_createElementVNode("video", {
        class: "videos",
        controls: "",
        src: get_message(__props.items.content, 3)
      }, null, 8, _hoisted_31)])) : __props.items.msgtype == 'weapp' ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_hoisted_34, _createElementVNode("span", null, _toDisplayString(get_message(__props.items.content, 6).description), 1)]), _createElementVNode("div", _hoisted_35, _toDisplayString(get_message(__props.items.content, 6).title), 1), _hoisted_36])) : __props.items.msgtype == 'link' ? (_openBlock(), _createElementBlock("div", {
        key: 13,
        class: "box_link",
        onClick: _cache[0] || (_cache[0] = $event => set_bark(get_message(__props.items.content, 13).link_url))
      }, [_createElementVNode("div", _hoisted_37, _toDisplayString(get_message(__props.items.content, 13).link_url), 1), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, _toDisplayString(get_message(__props.items.content, 13).title), 1), _createElementVNode("div", _hoisted_40, _toDisplayString(get_message(__props.items.content, 13).description), 1)])])) : __props.items.msgtype == 'voiptext' ? (_openBlock(), _createElementBlock("div", {
        key: 14,
        class: _normalizeClass(["cont_texts", __props.items.user_type == 1 ? 'color_11' : 'color_22'])
      }, [_createElementVNode("div", _hoisted_41, [_hoisted_42, _createElementVNode("span", _hoisted_43, _toDisplayString(date_time(get_message(__props.items.content, 7).callduration)), 1), _hoisted_44])], 2)) : __props.items.msgtype == 'chatrecord' ? (_openBlock(), _createElementBlock("div", _hoisted_45, "会话消息记录")) : __props.items.msgtype == 'card' ? (_openBlock(), _createElementBlock("div", _hoisted_46, [_hoisted_47, _createElementVNode("div", _hoisted_48, _toDisplayString(get_message(__props.items.content, 11).corpname), 1), _hoisted_49])) : _createCommentVNode("", true)])], 2)]);
    };
  }
});